import { render, staticRenderFns } from "./payslip_list.vue?vue&type=template&id=2ad2f05d&scoped=true&"
import script from "./payslip_list.vue?vue&type=script&lang=js&"
export * from "./payslip_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2f05d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ad2f05d', component.options)
    } else {
      api.reload('2ad2f05d', component.options)
    }
    module.hot.accept("./payslip_list.vue?vue&type=template&id=2ad2f05d&scoped=true&", function () {
      api.rerender('2ad2f05d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/payroll/payslip_list.vue"
export default component.exports